import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import axios from "../../HOC/axiosClient";
import config from "../../Config/applicationEnv";
import { Button, message } from "antd";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import "./EmailRecord.css";

const today = () => {
  const d = new Date();
  return d.toISOString().slice(0, 10);
};
const weekAgo = () => {
  const d = new Date();
  d.setDate(d.getDate() - 7);
  return d.toISOString().slice(0, 10);
};

const CustomReport = () => {
  const [fromDate, setFromDate] = useState(weekAgo());
  const [toDate, setToDate] = useState(today());
  const [loading, setLoading] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [userList, setUserList] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");

  const token = JSON.parse(localStorage.getItem("slotbook"));
  const accessToken = token?.accessToken;
  const isAdmin = token?.roleId != null && String(token.roleId) === "1";

  const colDefs = [
    { field: "S.No", valueGetter: "node.rowIndex + 1" },
    { field: "user_name", headerName: "User Name" },
    { field: "receiver_email", headerName: "Receiver Email" },
    { field: "cc", headerName: "CC" },
    { field: "body_preview", headerName: "Body" },
    { field: "subject", headerName: "Subject" },
    {
      field: "sent_at",
      headerName: "Sent At",
      valueGetter: (params) =>
        params?.data?.sent_at
          ? new Date(params.data.sent_at).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })
          : "",
    },
    {
      field: "success",
      headerName: "Status",
      valueGetter: (params) => (params.data?.success ? "Success" : "Failed"),
    },
  ];

  useEffect(() => {
    if (!isAdmin) return;
    const fetchUsers = async () => {
      try {
        const res = await axios.get(
          `${config.BASE_URL}exam_sch/api/user_table/create?page_size=200`,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        );
        const list = res.data?.results || res.data || [];
        setUserList(Array.isArray(list) ? list : []);
      } catch (e) {
        console.error("Failed to load user list", e);
      }
    };
    fetchUsers();
  }, [isAdmin, accessToken]);

  const loadReport = async () => {
    setLoading(true);
    try {
      const fromStr = fromDate;
      const toStr = toDate;
      let url = `${config.BASE_URL}exam_sch/api/search-emails-date-range/?from_date=${fromStr}&to_date=${toStr}`;
      if (selectedUserId) url += `&user_id=${selectedUserId}`;

      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      const data = response.data?.data || [];
      setRowData(data);
      message.success(`Loaded ${data.length} record(s).`);
    } catch (error) {
      console.error("Custom report error", error);
      message.error(error.response?.data?.error || "Failed to load report.");
    } finally {
      setLoading(false);
    }
  };

  const downloadExcel = () => {
    if (!rowData.length) {
      message.warning("No data to download.");
      return;
    }
    const ws = XLSX.utils.json_to_sheet(rowData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Custom Report");
    XLSX.writeFile(wb, `custom_email_report_${fromDate}_to_${toDate}.xlsx`);
    message.success("Download started.");
  };

  return (
    <div className="email-record-page body12">
      <div className="email-record-container container123456">
        <div className="breadcrumb flat">
          <Link to="/email">Home</Link>
          <span className="breadcrumb-sep"> / </span>
          <span className="active">Custom Report (date range)</span>
        </div>

        <div className="email-record-controls">
          <div className="email-record-date-wrap">
            <label className="email-record-date-label">From date</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              className="email-record-date-picker"
              style={{ padding: "8px", borderRadius: "8px" }}
            />
          </div>
          <div className="email-record-date-wrap">
            <label className="email-record-date-label">To date</label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              className="email-record-date-picker"
              style={{ padding: "8px", borderRadius: "8px" }}
            />
          </div>
          {isAdmin && (
            <div className="email-record-date-wrap">
              <label className="email-record-date-label">User (optional)</label>
              <select
                value={selectedUserId}
                onChange={(e) => setSelectedUserId(e.target.value)}
                style={{ padding: "8px 12px", borderRadius: "8px", minWidth: "200px" }}
              >
                <option value="">All users</option>
                {userList.map((u) => (
                  <option key={u.id} value={u.id}>
                    {u.user_name || u.user_email || `User ${u.id}`}
                  </option>
                ))}
              </select>
            </div>
          )}
          <div className="email-record-date-wrap" style={{ alignSelf: "flex-end" }}>
            <Button type="primary" onClick={loadReport} loading={loading}>
              Load Report
            </Button>
            <Button onClick={downloadExcel} disabled={!rowData.length} style={{ marginLeft: 8 }}>
              Download Excel
            </Button>
          </div>
        </div>

        <div className="email-record-table-wrap">
          {rowData.length > 0 ? (
            <div className="ag-theme-quartz email-record-grid" style={{ height: "70vh", width: "100%" }}>
              <AgGridReact
                rowData={rowData}
                columnDefs={colDefs}
                pagination={false}
                domLayout="normal"
                loading={loading}
              />
            </div>
          ) : (
            <div className="email-record-empty">
              <p>Select date range and click &quot;Load Report&quot; to see email records.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomReport;
